import { Link, useParams } from "react-router-dom";
import { PageHeader } from "../components/ui";
import DatabasePanel from "../components/DatabasePanel";

/** Tela dedicada do banco do projeto gerado: /projects/:id/database */
export default function DatabasePage() {
  const { id = "" } = useParams();

  return (
    <div className="space-y-4">
      <PageHeader
        title="Banco do projeto"
        description="Estrutura e registros do banco de desenvolvimento deste projeto."
        actions={
          <Link to={`/projects/${id}/builder`} className="text-xs text-brand hover:underline">
            Voltar ao Builder
          </Link>
        }
      />
      <DatabasePanel projectId={id} />
    </div>
  );
}
